export const EXAMPLE_TICKET_ID = 'C2S5DK3GV';

export const EXAMPLE_QRCODE_ALT = 'ticket_QR_code';

export const EXAMPLE_TICKET_BUTTON_LABEL = 'Apple Wallet';

export const EXAMPLE_LOCATION_ALT = 'Default_location';

export const EXAMPLE_COMPANY_ADDRESS = '123 Front St W, Toronto, ON M5J 2M2';

export const EXAMPLE_COMPANY_COPYRIGHT = `© ${new Date().getFullYear()} Universe.com`;

export enum EDITOR_TYPES {
  LOGO = 'logo',
  TITLE = 'title',
  CONTENT = 'content',
  EVENT = 'event',
  ACCESSIBILITY_DESCRIPTION = 'accessibilityDescription',
  ADDITIONAL_INFO = 'additionalInfo',
  HAVE_QUESTIONS = 'questions',
}

export enum LOGO_TYPES {
  BLACK = 'black',
  BLUE = 'blue',
}

export const EMAIL_TEMPLATE_FIELDS = {
  title: 'title',
  content: 'content',
  subject: 'subject',
  colorScheme: 'colorScheme',
  name: 'name',
  rates: 'rates',
};

export const DEFAULT_COLOR = {
  link: '#3A66E5',
  ticketHeader: '#1C232B',
};

export enum SOCIAL_KEYS {
  SOCIAL= 'social',
  URL = 'url',
}

export enum SOCIAL_PROPERTIES {
  HOMEPAGE = 'homepage',
  FACEBOOK = 'facebook',
  YOUTUBE = 'youtube',
  INSTAGRAM = 'instagram',
  SPOTIFY = 'spotify',
  TWITTER = 'twitter',
  APPLE_MUSIC = 'appleMusic',
  SOUNDCLOUD = 'soundCloud',
  TIDAL = 'tidal',
}

export const SOCIAL_TEXT_MAP = {
  [SOCIAL_PROPERTIES.HOMEPAGE]: 'Homepage',
  [SOCIAL_PROPERTIES.FACEBOOK]: 'Facebook',
  [SOCIAL_PROPERTIES.YOUTUBE]: 'YouTube',
  [SOCIAL_PROPERTIES.INSTAGRAM]: 'Instagram',
  [SOCIAL_PROPERTIES.SPOTIFY]: 'Spotify',
  [SOCIAL_PROPERTIES.TWITTER]: 'X',
  [SOCIAL_PROPERTIES.APPLE_MUSIC]: 'Apple Music',
  [SOCIAL_PROPERTIES.SOUNDCLOUD]: 'SoundCloud',
  [SOCIAL_PROPERTIES.TIDAL]: 'Tidal',
};

export const SOCIALS_OPTIONS = Object.entries(SOCIAL_TEXT_MAP).map(([key, text]) => {
  return ({
    key,
    text,
    value: key,
  });
});

export const TERMS_URL = '/terms';

// eslint-disable-next-line max-len
export const MANAGE_TEMPLATE_SUPPORT_LINK = 'https://support.universe.com/hc/articles/33507825921677-Customize-Your-Confirmation-Emails';

export const DISCLAIMER_MESSAGES = {
  en:
    'If you or someone you know is being forced to engage in commercial sex or labor trafficking,'+
    ' text 233-733 (Be Free) or call the National Human Trafficking Hotline at 1-888-373-7888 or '+
    'the California Coalition to Abolish Slavery and Trafficking (CAST) at 1-888-KEY-2-FRE(EDOM) '+
    'or 1-888-539-2373 to access help and services.' +
    '\n\n' +
    'It is a felony in California to knowingly engage in commercial trafficking and perpetrators '+
    'of this offense shall be prosecuted under the law.',
  es:
    'Si a usted, o a alguien que conoce, lo están forzando a hacer algo y no lo dejan ir – ya ' +
    'sea sexo por dinero, trabajo de hogar, de campo agrícola, construcción, fábrica, en una ' +
    'tienda minorista o restaurante, o cualquier otra actividad – envíe un texto 233-733 ' +
    '(Be Free) o llame a la Línea Nacional Contra la Trata de Personas ' +
    '(National Human Trafficking Hotline) al 1-888-373-7888 o a la Coalición de California ' +
    'para la Abolición de la Esclavitud y la Trata de Personas (California Coalition to ' +
    'Abolish Slavery and Trafficking, CAST) al 1-888-KEY-2-FRE(EDOM) o 1-888-539-2373 para ' +
    'obtener ayuda y servicios.' +
    '\n\n' +
    'Las víctimas de esclavitud y trata de personas están protegidas bajo las leyes de ' +
    'California y los Estados Unidos.',
  cn:
    '如果您本人或您  的人被迫从事任何活 且无法脱身 – 无 是商 性交易, 家   ,   工作,建筑, ' +
    '  工厂, 零售, 餐 工作 是任何其他活  –   短信233-733 (Be Free) 或者 打全美反人口       ' +
    '(National Human Trafficking Hotline) 1-888-373-7888 或打   加州 除奴役和人口   盟  '+
    '(California Coalition to Abolish Slavery and Trafficking, CAST),   号 1-888-KEY-2- ' +
    'FRE(EDOM) 或 1-888-539-2373,  得帮助和 服 。'+
    '\n\n' +
    '奴役和人口  受害者受美国和加州法律的保 。',
};

export const CUSTOMIZABLE_IMAGES = {
  HEIGHT: 52,
  WIDTH: 110,
};
